const typography = {
  fontFamily: [
    // Preferred font family
    'Roboto',
    // Fallback font families
    '-apple-system',
    'BlinkMacSystemFont',
    '"Segoe UI"',
    'Oxygen',
    'Ubuntu',
    'Cantarell',
    '"Fira Sans"',
    '"Droid Sans"',
    'sans-serif',
  ].join(','),
  h1: {
    fontSize: '1.5rem', // 24px
    fontWeight: 400,
  },
  h2: {
    fontSize: '1.25rem', // 20px
    fontWeight: 500,
  },
  body1: {
    fontSize: '1rem', // 16px
    fontWeight: 400,
  },
  body2: {
    fontSize: '0.875rem', // 14px
    fontWeight: 400,
  },
  subtitle1: {
    fontSize: '1rem', // 16px
    fontWeight: 400,
  },
  subtitle2: {
    fontSize: '0.875rem', // 14px
    color: 'var(--text-info)',
    fontWeight: 500,
  },
  overline: {
    fontSize: '0.75rem', // 12px
    fontWeight: 400,
  },
  caption: {
    fontSize: '0.75rem', // 12px
    fontWeight: 400,
    color: 'var(--text-secondary)',
  },
  button: {
    large: {
      fontSize: '0.9375rem', // 15px
      fontWeight: 500,
    },
    medium: {
      fontSize: '0.875rem', // 14px
      fontWeight: 500,
    },
    small: {
      fontSize: '0.8125rem', // 13px
      fontWeight: 500,
    },
  },
};

export default typography;
